import { BaseEntity } from './base-entity';

export interface County extends BaseEntity {
  code: string;
  name: string;
}

export namespace County {

  export function equals(county1: County, county2: County): boolean {
    return county1 && county2
      ? county1.name === county2.name
      : county1 === county2;
  }
}
